import DateInput from "@/components/Common/DateInput/DateInput.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { stateItems } from "@/configuration/formConfigurations";
export default {
  components: { DateInput, InfoDialog },
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    stateItems,
    waterQualityItems: [
      { id: "excellent", title: "Ausgezeichnet" },
      { id: "good", title: "Gut" },
      { id: "sufficient", title: "Ausreichend" },
      { id: "insufficient", title: "Mangel" }
    ]
  })
};
